import { localeSetActions, localeGetActions } from "./index.js";
//import productActions from "Actions/productActions";
import appActions from "Actions/appActions";
import Locale from "Services/locale";
import Countries from "Services/http/countries";
import ShippingMethods from "Services/shippingmethods";
import cloneDeep from "lodash/cloneDeep";

const localeUpdateActions = (function() {
  const actions = {
    updateLanguage: language => {
      return (dispatch, getState) => {
        let { country } = getState().locale;
        let updatedLocale = Locale.createLocale(country, language);
        dispatch(localeSetActions.setLanguage(language));
        dispatch(localeSetActions.setLocale(updatedLocale));
        dispatch(localeGetActions.getTranslations(updatedLocale));
        //dispatch(productActions.getProductData());
      };
    },
    updateCountry: country => {
      return (dispatch, getState) => {
        dispatch(localeSetActions.setCountry(country));
        dispatch(localeSetActions.setState(null));
        dispatch(localeGetActions.getMarketCurrency());
        dispatch(localeGetActions.getLangOptions());
        dispatch(localeGetActions.getDefaultLanguage());
        dispatch(localeGetActions.getLocale());
        let availableLanguage = getState().locale.langOptions[0].code;
        dispatch(actions.updateLanguage(availableLanguage));
        //dispatch(productActions.getProductData());
        //dispatch(localeGetActions.getCountryRegions());
      };
    },
    updateCountryAndLanguage: (country, language) => {
      return (dispatch, getState) => {
        dispatch(actions.updateLanguage(language));
        
        dispatch(localeSetActions.setCountry(country));
        dispatch(localeSetActions.setState(null));
        dispatch(localeGetActions.getMarketCurrency());
        dispatch(localeGetActions.getLangOptions());
        dispatch(localeGetActions.getDefaultLanguage());
        dispatch(localeGetActions.getLocale());
        //let availableLanguage = getState().locale.langOptions[0].code;
        
        //dispatch(productActions.getProductData());
        //dispatch(localeGetActions.getCountryRegions());
      };
    },
    updateBillingRegion: (country) => {
      return (dispatch, State) => {
        dispatch(appActions.setIsLoading(true));
        Countries.getRegions(country).done(regions => {
          dispatch(appActions.setIsLoading(false));
          dispatch(localeSetActions.setBillingRegions(regions));
        });
      };
    },
    filterShippingMethods: () => {
      return (dispatch, getState) => {
          let shippingMethods = getState().locale.shippingMethods;
          let clonedShippingMethods = cloneDeep(shippingMethods);
          let filteredShippingMethods = ShippingMethods.filterByIOShipOptions(clonedShippingMethods,getState().products.ioShipMethod);
          dispatch(localeSetActions.setFilteredShippingMethods(filteredShippingMethods));
      }
    }
  };

  return actions;
})();

export default localeUpdateActions;



// WEBPACK FOOTER //
// ./src/store/actions/localeActions/localeUpdateActions.js